/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DtrLog } from '../models/dtr-log';
import { DtrLogWithInfo } from '../models/dtr-log-with-info';
import { Entity } from '../models/entity';
import { LogCard } from '../models/log-card';
import { CardUser } from '../models/card-user';
import { ClientDetails } from '../models/client-details';
import { SimplifiedEntity } from '../models/simplified-entity';

@Injectable({
  providedIn: 'root',
})
export class TapioService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiTapioGetCardsByEntityIdGet
   */
  static readonly ApiTapioGetCardsByEntityIdGetPath = '/api/Tapio/getCardsByEntityId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardsByEntityIdGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Plain$Response(params?: {
    ENTITY_ID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<LogCard>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetCardsByEntityIdGetPath, 'get');
    if (params) {
      rb.query('ENTITY_ID', params.ENTITY_ID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LogCard>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardsByEntityIdGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Plain(params?: {
    ENTITY_ID?: string;
    Authorization?: string;
  }): Observable<Array<LogCard>> {

    return this.apiTapioGetCardsByEntityIdGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LogCard>>) => r.body as Array<LogCard>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardsByEntityIdGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Json$Response(params?: {
    ENTITY_ID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<LogCard>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetCardsByEntityIdGetPath, 'get');
    if (params) {
      rb.query('ENTITY_ID', params.ENTITY_ID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<LogCard>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardsByEntityIdGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardsByEntityIdGet$Json(params?: {
    ENTITY_ID?: string;
    Authorization?: string;
  }): Observable<Array<LogCard>> {

    return this.apiTapioGetCardsByEntityIdGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<LogCard>>) => r.body as Array<LogCard>)
    );
  }

  /**
   * Path part for operation apiTapioGetAllCardByEntityPagedGet
   */
  static readonly ApiTapioGetAllCardByEntityPagedGetPath = '/api/Tapio/GetAllCardByEntityPaged';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPagedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Plain$Response(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetAllCardByEntityPagedGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('page_no', params.page_no, {});
      rb.query('page_size', params.page_size, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SimplifiedEntity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPagedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Plain(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<Array<SimplifiedEntity>> {

    return this.apiTapioGetAllCardByEntityPagedGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>) => r.body as Array<SimplifiedEntity>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPagedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Json$Response(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetAllCardByEntityPagedGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('page_no', params.page_no, {});
      rb.query('page_size', params.page_size, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SimplifiedEntity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPagedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPagedGet$Json(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<Array<SimplifiedEntity>> {

    return this.apiTapioGetAllCardByEntityPagedGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>) => r.body as Array<SimplifiedEntity>)
    );
  }

  /**
   * Path part for operation apiTapioGetAllCardByEntityPaged2Get
   */
  static readonly ApiTapioGetAllCardByEntityPaged2GetPath = '/api/Tapio/GetAllCardByEntityPaged2';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPaged2Get$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Plain$Response(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetAllCardByEntityPaged2GetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('page_no', params.page_no, {});
      rb.query('page_size', params.page_size, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SimplifiedEntity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPaged2Get$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Plain(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<Array<SimplifiedEntity>> {

    return this.apiTapioGetAllCardByEntityPaged2Get$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>) => r.body as Array<SimplifiedEntity>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetAllCardByEntityPaged2Get$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Json$Response(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<SimplifiedEntity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetAllCardByEntityPaged2GetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('page_no', params.page_no, {});
      rb.query('page_size', params.page_size, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SimplifiedEntity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetAllCardByEntityPaged2Get$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetAllCardByEntityPaged2Get$Json(params?: {
    CLIENT_ID?: string;
    page_no?: number;
    page_size?: number;
    Authorization?: string;
  }): Observable<Array<SimplifiedEntity>> {

    return this.apiTapioGetAllCardByEntityPaged2Get$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<SimplifiedEntity>>) => r.body as Array<SimplifiedEntity>)
    );
  }

  /**
   * Path part for operation apiTapioGetCardDetailsGet
   */
  static readonly ApiTapioGetCardDetailsGetPath = '/api/Tapio/GetCardDetails';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardDetailsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Plain$Response(params?: {
    CARD_UID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<CardUser>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetCardDetailsGetPath, 'get');
    if (params) {
      rb.query('CARD_UID', params.CARD_UID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CardUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardDetailsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Plain(params?: {
    CARD_UID?: string;
    Authorization?: string;
  }): Observable<CardUser> {

    return this.apiTapioGetCardDetailsGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<CardUser>) => r.body as CardUser)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetCardDetailsGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Json$Response(params?: {
    CARD_UID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<CardUser>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetCardDetailsGetPath, 'get');
    if (params) {
      rb.query('CARD_UID', params.CARD_UID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CardUser>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetCardDetailsGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetCardDetailsGet$Json(params?: {
    CARD_UID?: string;
    Authorization?: string;
  }): Observable<CardUser> {

    return this.apiTapioGetCardDetailsGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<CardUser>) => r.body as CardUser)
    );
  }

  /**
   * Path part for operation apiTapioGetDtrLogsByDatePagedGet
   */
  static readonly ApiTapioGetDtrLogsByDatePagedGetPath = '/api/Tapio/GetDtrLogsByDatePaged';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetDtrLogsByDatePagedGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Plain$Response(params?: {
    CLIENT_ID?: string;
    DATE_FROM?: string;
    page_size?: number;
    page_no?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<DtrLogWithInfo>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetDtrLogsByDatePagedGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('DATE_FROM', params.DATE_FROM, {});
      rb.query('page_size', params.page_size, {});
      rb.query('page_no', params.page_no, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DtrLogWithInfo>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetDtrLogsByDatePagedGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Plain(params?: {
    CLIENT_ID?: string;
    DATE_FROM?: string;
    page_size?: number;
    page_no?: number;
    Authorization?: string;
  }): Observable<Array<DtrLogWithInfo>> {

    return this.apiTapioGetDtrLogsByDatePagedGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DtrLogWithInfo>>) => r.body as Array<DtrLogWithInfo>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetDtrLogsByDatePagedGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Json$Response(params?: {
    CLIENT_ID?: string;
    DATE_FROM?: string;
    page_size?: number;
    page_no?: number;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<DtrLogWithInfo>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetDtrLogsByDatePagedGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.query('DATE_FROM', params.DATE_FROM, {});
      rb.query('page_size', params.page_size, {});
      rb.query('page_no', params.page_no, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<DtrLogWithInfo>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetDtrLogsByDatePagedGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetDtrLogsByDatePagedGet$Json(params?: {
    CLIENT_ID?: string;
    DATE_FROM?: string;
    page_size?: number;
    page_no?: number;
    Authorization?: string;
  }): Observable<Array<DtrLogWithInfo>> {

    return this.apiTapioGetDtrLogsByDatePagedGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<DtrLogWithInfo>>) => r.body as Array<DtrLogWithInfo>)
    );
  }

  /**
   * Path part for operation apiTapioSearchUserGet
   */
  static readonly ApiTapioSearchUserGetPath = '/api/Tapio/SearchUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioSearchUserGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Plain$Response(params?: {
    ENTITY_ID?: string;
    USERNAME?: string;
    GET_CARDS?: boolean;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Entity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioSearchUserGetPath, 'get');
    if (params) {
      rb.query('ENTITY_ID', params.ENTITY_ID, {});
      rb.query('USERNAME', params.USERNAME, {});
      rb.query('GET_CARDS', params.GET_CARDS, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Entity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioSearchUserGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Plain(params?: {
    ENTITY_ID?: string;
    USERNAME?: string;
    GET_CARDS?: boolean;
    Authorization?: string;
  }): Observable<Array<Entity>> {

    return this.apiTapioSearchUserGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Entity>>) => r.body as Array<Entity>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioSearchUserGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Json$Response(params?: {
    ENTITY_ID?: string;
    USERNAME?: string;
    GET_CARDS?: boolean;
    Authorization?: string;
  }): Observable<StrictHttpResponse<Array<Entity>>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioSearchUserGetPath, 'get');
    if (params) {
      rb.query('ENTITY_ID', params.ENTITY_ID, {});
      rb.query('USERNAME', params.USERNAME, {});
      rb.query('GET_CARDS', params.GET_CARDS, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Entity>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioSearchUserGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioSearchUserGet$Json(params?: {
    ENTITY_ID?: string;
    USERNAME?: string;
    GET_CARDS?: boolean;
    Authorization?: string;
  }): Observable<Array<Entity>> {

    return this.apiTapioSearchUserGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Entity>>) => r.body as Array<Entity>)
    );
  }

  /**
   * Path part for operation apiTapioGetClientInfoGet
   */
  static readonly ApiTapioGetClientInfoGetPath = '/api/Tapio/GetClientInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetClientInfoGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Plain$Response(params?: {
    CLIENT_ID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<ClientDetails>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetClientInfoGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDetails>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetClientInfoGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Plain(params?: {
    CLIENT_ID?: string;
    Authorization?: string;
  }): Observable<ClientDetails> {

    return this.apiTapioGetClientInfoGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDetails>) => r.body as ClientDetails)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioGetClientInfoGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Json$Response(params?: {
    CLIENT_ID?: string;
    Authorization?: string;
  }): Observable<StrictHttpResponse<ClientDetails>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioGetClientInfoGetPath, 'get');
    if (params) {
      rb.query('CLIENT_ID', params.CLIENT_ID, {});
      rb.header('Authorization', params.Authorization, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ClientDetails>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioGetClientInfoGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTapioGetClientInfoGet$Json(params?: {
    CLIENT_ID?: string;
    Authorization?: string;
  }): Observable<ClientDetails> {

    return this.apiTapioGetClientInfoGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<ClientDetails>) => r.body as ClientDetails)
    );
  }

  /**
   * Path part for operation apiTapioAddCardPost
   */
  static readonly ApiTapioAddCardPostPath = '/api/Tapio/AddCard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioAddCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Plain$Response(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioAddCardPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioAddCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Plain(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<number> {

    return this.apiTapioAddCardPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioAddCardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Json$Response(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioAddCardPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioAddCardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioAddCardPost$Json(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<number> {

    return this.apiTapioAddCardPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation apiTapioUpdateCardPost
   */
  static readonly ApiTapioUpdateCardPostPath = '/api/Tapio/UpdateCard';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUpdateCardPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Plain$Response(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioUpdateCardPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioUpdateCardPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Plain(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<number> {

    return this.apiTapioUpdateCardPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUpdateCardPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Json$Response(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioUpdateCardPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioUpdateCardPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUpdateCardPost$Json(params?: {
    Authorization?: string;
    body?: LogCard
  }): Observable<number> {

    return this.apiTapioUpdateCardPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation apiTapioUploadDtrLogsPost
   */
  static readonly ApiTapioUploadDtrLogsPostPath = '/api/Tapio/UploadDtrLogs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUploadDtrLogsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Plain$Response(params?: {
    Authorization?: string;
    body?: Array<DtrLog>
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioUploadDtrLogsPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioUploadDtrLogsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Plain(params?: {
    Authorization?: string;
    body?: Array<DtrLog>
  }): Observable<number> {

    return this.apiTapioUploadDtrLogsPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTapioUploadDtrLogsPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Json$Response(params?: {
    Authorization?: string;
    body?: Array<DtrLog>
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TapioService.ApiTapioUploadDtrLogsPostPath, 'post');
    if (params) {
      rb.header('Authorization', params.Authorization, {});
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiTapioUploadDtrLogsPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiTapioUploadDtrLogsPost$Json(params?: {
    Authorization?: string;
    body?: Array<DtrLog>
  }): Observable<number> {

    return this.apiTapioUploadDtrLogsPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
